export namespace Theme {
  enum Colors {
    white = '#FFFFFF',
    lightGrey = '#E5E5E5',
    grey = '#CECECE',
    black = '#000000',
    darkGrey = '#292929',

    red = '#DB0007',
    orange = '#FFBC0D',
    yellow = '#FFCD4B',
    green = '#004E31'
  }

  enum Aliases {
    disabled = Colors.lightGrey,
    border = Colors.grey,
    text = Colors.black,
    error = Colors.red
  }

  export const color = {
    ...Aliases,
    ...Colors
  };

  export const font = {
    family: {
      roboto: 'Roboto',
      speedee: 'Speedee',
      speedeeCondensed: 'Speedee Condensed'
    },

    style: {
      normal: 'normal',
      italic: 'italic'
    },

    weight: {
      regular: 400,
      bold: 700
    }
  };

  export const rems = (px: number) => `${px * 0.0625}rem`;

  export const breakpoint = {
    md: '@media only screen and (max-width: 1199px)',
    sm: '@media only screen and (max-width: 1023px)',
    xs: '@media only screen and (max-width: 359px)'
  };
}
